import { render, staticRenderFns } from "./publishPlatforms.vue?vue&type=template&id=66cd2808&scoped=true&"
import script from "./publishPlatforms.vue?vue&type=script&lang=js&"
export * from "./publishPlatforms.vue?vue&type=script&lang=js&"
import style0 from "./publishPlatforms.vue?vue&type=style&index=0&id=66cd2808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd2808",
  null
  
)

component.options.__file = "publishPlatforms.vue"
export default component.exports